'use strict';

exports.__esModule = true;
exports.createAddPropertiesToFunction = exports.unshift = exports.splice = exports.createSetNewCachedValue = exports.createGetCacheKey = exports.getGetCacheKeyMethod = exports.getStandardCacheKeyCustomEquals = exports.getStandardCacheKey = exports.getSerializedCacheKeyCustomEquals = exports.getSerializedCacheKey = exports.getReactCacheKeyCustomEquals = exports.getReactCacheKey = exports.getKeyCount = exports.getFunctionName = exports.getFunctionNameViaRegexp = exports.getDefaultedOptions = exports.findIndexAfterFirst = exports.findIndex = exports.createPromiseResolver = exports.createPromiseRejecter = exports.createPluckFromInstanceList = exports.createFindIndex = exports.createCurriableOptionMethod = exports.compose = exports.addStaticPropertiesToFunction = exports.take = exports.isValueObjectOrArray = exports.isPlainObject = exports.isMoized = exports.isFunction = exports.isFiniteAndPositiveInteger = exports.isComplexObject = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// cache


// cache key


// constants


// serialize


var _Cache = require('./Cache');

var _Cache2 = _interopRequireDefault(_Cache);

var _ReactCacheKey = require('./ReactCacheKey');

var _ReactCacheKey2 = _interopRequireDefault(_ReactCacheKey);

var _SerializedCacheKey = require('./SerializedCacheKey');

var _SerializedCacheKey2 = _interopRequireDefault(_SerializedCacheKey);

var _SingleParameterCacheKey = require('./SingleParameterCacheKey');

var _SingleParameterCacheKey2 = _interopRequireDefault(_SingleParameterCacheKey);

var _MultipleParameterCacheKey = require('./MultipleParameterCacheKey');

var _MultipleParameterCacheKey2 = _interopRequireDefault(_MultipleParameterCacheKey);

var _constants = require('./constants');

var _serialize = require('./serialize');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @private
 *
 * @function isComplexObject
 *
 * @description
 * is the object passed a complex object
 *
 * @param {*} object object to test if it is complex
 * @returns {boolean} is it a complex object
 */


// types
var isComplexObject = exports.isComplexObject = function isComplexObject(object) {
  return !!object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === _constants.OBJECT_TYPEOF;
};

/**
 * @private
 *
 * @function isFiniteAndPositiveInteger
 *
 * @description
 * is the number passed an integer that is finite and positive
 *
 * @param {number} number number to test for finiteness and positivity
 * @returns {boolean} is the number finite and positive
 */
var isFiniteAndPositiveInteger = exports.isFiniteAndPositiveInteger = function isFiniteAndPositiveInteger(number) {
  return _constants.FINITE_POSITIVE_INTEGER.test('' + number);
};

/**
 * @private
 *
 * @function isFunction
 *
 * @description
 * is the object passed a function or not
 *
 * @param {*} object object to test
 * @returns {boolean} is it a function
 */
var isFunction = exports.isFunction = function isFunction(object) {
  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === _constants.FUNCTION_TYPEOF;
};

/**
 * @private
 *
 * @function isMoized
 *
 * @description
 * is the function passed a moized function or not
 *
 * @param {*} fn the function to get if moize
 * @returns {boolean} is the function moized or not
 */
var isMoized = exports.isMoized = function isMoized(fn) {
  return isFunction(fn) && !!fn.isMoized;
};

/**
 * @private
 *
 * @function isPlainObject
 *
 * @description
 * is the object passed a plain object or not
 *
 * @param {*} object object to test
 * @returns {boolean} is it a plain object
 */
var isPlainObject = exports.isPlainObject = function isPlainObject(object) {
  return isComplexObject(object) && object.constructor === Object;
};

/**
 * @private
 *
 * @function isValueObjectOrArray
 *
 * @description
 * check if the object is actually an object or array
 *
 * @param {*} object object to test
 * @returns {boolean} is the object an object or array
 */
var isValueObjectOrArray = exports.isValueObjectOrArray = function isValueObjectOrArray(object) {
  if (!isComplexObject(object)) {
    return false;
  }

  var index = 0;

  while (index < _constants.GOTCHA_OBJECT_CLASSES.length) {
    if (object instanceof _constants.GOTCHA_OBJECT_CLASSES[index]) {
      return false;
    }

    index++;
  }

  return true;
};

/**
 * @private
 *
 * @function take
 *
 * @description
 * take the first N number of items from the array (faster than slice)
 *
 * @param {number} size the number of items to take
 * @returns {function(Array<*>): Array<*>} the shortened array
 */
var take = exports.take = function take(size) {
  return function (array) {
    if (size >= array.length) {
      return array;
    }

    switch (size) {
      case 1:
        return [array[0]];

      case 2:
        return [array[0], array[1]];

      case 3:
        return [array[0], array[1], array[2]];

      case 4:
        return [array[0], array[1], array[2], array[3]];

      case 5:
        return [array[0], array[1], array[2], array[3], array[4]];
    }

    return array.slice(0, size);
  };
};

/**
 * @private
 *
 * @function addStaticPropertiesToFunction
 *
 * @description
 * add static properties to the memoized function if they exist on the original
 *
 * @param {function} originalFunction the function to be memoized
 * @param {function} memoizedFn the higher-order memoized function
 * @returns {function} memoizedFn with static properties added
 */
var addStaticPropertiesToFunction = exports.addStaticPropertiesToFunction = function addStaticPropertiesToFunction(originalFunction, memoizedFn) {
  var index = _constants.STATIC_PROPERTIES_TO_PASS.length,
      property = void 0;

  while (index--) {
    property = _constants.STATIC_PROPERTIES_TO_PASS[index];

    if (originalFunction[property]) {
      memoizedFn[property] = originalFunction[property];
    }
  }

  return memoizedFn;
};

/**
 * @private
 *
 * @function compose
 *
 * @description
 * method to compose functions and return a single function
 *
 * @param {...Array<function>} functions the functions to compose
 * @returns {function(...Array<*>): *} the composed function
 */
var compose = exports.compose = function compose() {
  for (var _len = arguments.length, functions = Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return functions.reduce(function (f, g) {
    return function () {
      return f(g.apply(undefined, arguments));
    };
  });
};

/**
 * @private
 *
 * @function createCurriableOptionMethod
 *
 * @description
 * create a method that will curry moize with the option + value passed
 *
 * @param {function} fn the method to call
 * @param {string} option the name of the option to apply
 * @param {*} value the value to assign to option
 * @returns {function} the moizer with the option pre-applied
 */
var createCurriableOptionMethod = exports.createCurriableOptionMethod = function createCurriableOptionMethod(fn, option) {
  return function (value) {
    var _fn;

    return fn((_fn = {}, _fn[option] = value, _fn));
  };
};

/**
 * @private
 *
 * @function createFindIndex
 *
 * @description
 * create a findIndex method based on the startingIndex passed
 *
 * @param {number} startingIndex the index to start in the find method returned
 * @returns {function(Array<ListItem>, *): number} the findIndex method
 */
var createFindIndex = exports.createFindIndex = function createFindIndex(startingIndex) {
  // eslint-disable-line no-use-before-define
  return function (list, key) {
    var index = startingIndex;

    while (index < list.length) {
      if (key === list[index].key) {
        return index;
      }

      index++;
    }

    return -1;
  };
};

/**
 * @private
 *
 * @function createPluckFromInstanceList
 *
 * @description
 * get a property from the list on the cache
 *
 * @param {{list: Array<Object>}} cache cache whose list to map over
 * @param {string} key key to pluck from list
 * @returns {Array<*>} array of values plucked at key
 */
var createPluckFromInstanceList = exports.createPluckFromInstanceList = function createPluckFromInstanceList(cache, key) {
  return function () {
    return cache.list.map(function (item) {
      return item[key];
    });
  };
};

/**
 * @private
 *
 * @function createPromiseRejecter
 *
 * @description
 * create method that will reject the promise and delete the key from cache
 *
 * @param {Cache} cache cache to update
 * @param {*} key key to delete from cache
 * @param {function} promiseLibrary the promise library used
 * @returns {function} the rejecter function for the promise
 */
var createPromiseRejecter = exports.createPromiseRejecter = function createPromiseRejecter(cache, key, _ref) {
  var promiseLibrary = _ref.promiseLibrary;

  return function (exception) {
    cache.remove(key);

    return promiseLibrary.reject(exception);
  };
};

/**
 * @private
 *
 * @function createPromiseResolver
 *
 * @description
 * create method that will resolve the promise and update the key in cache
 *
 * @param {Cache} cache cache to update
 * @param {*} key key to update in cache
 * @param {boolean} hasMaxAge should the cache expire after some time
 * @param {number} maxAge the age after which the cache will be expired
 * @param {function} onExpire a callback that is called after removing the key
 * @param {function} promiseLibrary the promise library used
 * @returns {function} the resolver function for the promise
 */
var createPromiseResolver = exports.createPromiseResolver = function createPromiseResolver(cache, key, hasMaxAge, _ref2) {
  var maxAge = _ref2.maxAge,
      onExpire = _ref2.onExpire,
      promiseLibrary = _ref2.promiseLibrary;

  return function (resolvedValue) {
    cache.update(key, promiseLibrary.resolve(resolvedValue));

    if (hasMaxAge) {
      cache.expireAfter(key, maxAge, onExpire);
    }

    return resolvedValue;
  };
};

/**
 * @private
 *
 * @function findIndex
 *
 * @description
 * find the index of the key starting at the first index
 *
 * @param {Array<ListItem>} list the list to find the key in
 * @param {*} key the key to test against
 * @returns {number} the index of the matching key, or -1
 */
var findIndex = exports.findIndex = createFindIndex(0);

/**
 * @private
 *
 * @function findIndexAfterFirst
 *
 * @description
 * find the index of the key starting at the second index
 *
 * @param {Array<ListItem>} list the list to find the key in
 * @param {*} key the key to test against
 * @returns {number} the index of the matching key, or -1
 */
var findIndexAfterFirst = exports.findIndexAfterFirst = createFindIndex(1);

/**
 * @private
 *
 * @function getDefaultedOptions
 *
 * @description
 * get the options coalesced to their defaults
 *
 * @param {Object} options the options passed to the moize method
 * @returns {Options} the coalesced options object
 */
var getDefaultedOptions = exports.getDefaultedOptions = function getDefaultedOptions(options) {
  var coalescedOptions = _extends({}, _constants.DEFAULT_OPTIONS, options);

  if (coalescedOptions.serialize) {
    coalescedOptions.serializer = (0, _serialize.getSerializerFunction)(coalescedOptions);
  }

  return coalescedOptions;
};

/**
 * @private
 *
 * @function getFunctionNameViaRegexp
 *
 * @description
 * use regexp match on stringified function to get the function name
 *
 * @param {function} fn function to get the name of
 * @returns {string} function name
 */
var getFunctionNameViaRegexp = exports.getFunctionNameViaRegexp = function getFunctionNameViaRegexp(fn) {
  var match = fn.toString().match(_constants.FUNCTION_NAME_REGEXP);

  return match ? match[1] : '';
};

/**
 * @private
 *
 * @function getFunctionName
 *
 * @description
 * get the function name, either from modern property or regexp match,
 * falling back to generic string
 *
 * @param {function} fn function to get the name of
 * @returns {string} function name
 */
var getFunctionName = exports.getFunctionName = function getFunctionName(fn) {
  return fn.displayName || fn.name || getFunctionNameViaRegexp(fn) || _constants.FUNCTION_TYPEOF;
};

/**
 * @private
 *
 * @function getKeyCount
 *
 * @description
 * get the count of keys in the object (faster than Object.keys().length)
 *
 * @param {Object} object the object to get the key count of
 * @returns {number} the count of keys
 */
var getKeyCount = exports.getKeyCount = function getKeyCount(object) {
  var counter = 0;

  for (var ignored in object) {
    counter++;
  }

  return counter;
};

/**
 * @private
 *
 * @function getReactCacheKey
 *
 * @description
 * get the cache key specific to react
 *
 * @param {Cache} cache the cache to find a potential matching key in
 * @param {*} key the key to try to find a match of, or turn into a new ReactCacheKey
 * @returns {ReactCacheKey} the matching cache key, or a new one
 */
var getReactCacheKey = exports.getReactCacheKey = function getReactCacheKey(cache, key) {
  // $FlowIgnore if cache has size, the key exists
  if (cache.size && cache.lastItem.key.matches(key)) {
    // $FlowIgnore if the key matches, the key exists
    return cache.lastItem.key;
  }

  var index = 1;

  while (index < cache.size) {
    // $FlowIgnore if cache has size, the key exists
    if (cache.list[index].key.matches(key)) {
      // $FlowIgnore if the key matches, the key exists
      return cache.list[index].key;
    }

    index++;
  }

  return new _ReactCacheKey2.default(key);
};

/**
 * @private
 *
 * @function getReactCacheKey
 *
 * @description
 * get the cache key specific to react
 *
 * @param {Cache} cache the cache to find a potential matching key in
 * @param {*} key the key to try to find a match of, or turn into a new ReactCacheKey
 * @param {Options} options the options passed to the moized method
 * @returns {ReactCacheKey} the matching cache key, or a new one
 */
var getReactCacheKeyCustomEquals = exports.getReactCacheKeyCustomEquals = function getReactCacheKeyCustomEquals(cache, key, options) {
  // $FlowIgnore if cache has size, the key exists
  if (cache.size && cache.lastItem.key.matchesCustom(key, options.equals)) {
    // $FlowIgnore if the key matches, the key exists
    return cache.lastItem.key;
  }

  var index = 1;

  while (index < cache.size) {
    // $FlowIgnore if cache has size, the key exists
    if (cache.list[index].key.matchesCustom(key, options.equals)) {
      // $FlowIgnore if the key matches, the key exists
      return cache.list[index].key;
    }

    index++;
  }

  return new _ReactCacheKey2.default(key);
};

/**
 * @private
 *
 * @function getSerializedCacheKey
 *
 * @description
 * get the cache key specific to serialized methods
 *
 * @param {Cache} cache the cache to find a potential matching key in
 * @param {*} key the key to try to find a match of, or turn into a new SerializedCacheKey
 * @param {Options} options the options passed to the moized method
 * @returns {SerializedCacheKey} the matching cache key, or a new one
 */
var getSerializedCacheKey = exports.getSerializedCacheKey = function getSerializedCacheKey(cache, key) {
  // $FlowIgnore if cache has size, the key exists
  if (cache.size && cache.lastItem.key.matches(key)) {
    // $FlowIgnore if the key matches, the key exists
    return cache.lastItem.key;
  }

  var index = 1;

  while (index < cache.size) {
    // $FlowIgnore if cache has size, the key exists
    if (cache.list[index].key.matches(key)) {
      // $FlowIgnore if the key matches, the key exists
      return cache.list[index].key;
    }

    index++;
  }

  return new _SerializedCacheKey2.default(key);
};

/**
 * @private
 *
 * @function getSerializedCacheKeyCustomEquals
 *
 * @description
 * get the cache key specific to serialized methods
 *
 * @param {Cache} cache the cache to find a potential matching key in
 * @param {*} key the key to try to find a match of, or turn into a new SerializedCacheKey
 * @param {Options} options the options passed to the moized method
 * @returns {SerializedCacheKey} the matching cache key, or a new one
 */
var getSerializedCacheKeyCustomEquals = exports.getSerializedCacheKeyCustomEquals = function getSerializedCacheKeyCustomEquals(cache, key, options) {
  if (cache.size &&
  // $FlowIgnore if cache has size, the key exists
  cache.lastItem.key.matchesCustom(key, options.equals)) {
    // $FlowIgnore if the key matches, the key exists
    return cache.lastItem.key;
  }

  var index = 1;

  while (index < cache.size) {
    // $FlowIgnore if cache has size, the key exists
    if (cache.list[index].key.matchesCustom(key, options.equals)) {
      // $FlowIgnore if the key matches, the key exists
      return cache.list[index].key;
    }

    index++;
  }

  return new _SerializedCacheKey2.default(key);
};

/**
 * @private
 *
 * @function getStandardCacheKey
 *
 * @description
 * get the cache key for standard parameters, either single or multiple
 *
 * @param {Cache} cache the cache to find a potential matching key in
 * @param {*} key the key to try to find a match of, or turn into a new Multiple / SingleParameterCacheKey
 * @returns {StandardCacheKey} the matching cache key, or a new one
 */
var getStandardCacheKey = exports.getStandardCacheKey = function getStandardCacheKey(cache, key) {
  var isMultiParamKey = key.length > 1;

  // $FlowIgnore if cache has size, the key exists
  if (cache.size && cache.lastItem.key.matches(key, isMultiParamKey)) {
    // $FlowIgnore if the key matches, the key exists
    return cache.lastItem.key;
  }

  var index = 1;

  while (index < cache.size) {
    // $FlowIgnore if cache has size, the key exists
    if (cache.list[index].key.matches(key, isMultiParamKey)) {
      // $FlowIgnore if the key matches, the key exists
      return cache.list[index].key;
    }

    index++;
  }

  return isMultiParamKey ? new _MultipleParameterCacheKey2.default(key) : new _SingleParameterCacheKey2.default(key);
};

/**
 * @private
 *
 * @function getStandardCacheKeyCustomEquals
 *
 * @description
 * get the cache key for standard parameters, either single or multiple
 *
 * @param {Cache} cache the cache to find a potential matching key in
 * @param {*} key the key to try to find a match of, or turn into a new Multiple / SingleParameterCacheKey
 * @param {Options} options the options passed to the moized method
 * @returns {StandardCacheKey} the matching cache key, or a new one
 */
var getStandardCacheKeyCustomEquals = exports.getStandardCacheKeyCustomEquals = function getStandardCacheKeyCustomEquals(cache, key, options) {
  var isMultiParamKey = key.length > 1;

  if (cache.size &&
  // $FlowIgnore if cache has size, the key exists
  cache.lastItem.key.matchesCustom(key, isMultiParamKey, options.equals)) {
    // $FlowIgnore if the key matches, the key exists
    return cache.lastItem.key;
  }

  var index = 1;

  while (index < cache.size) {
    if (
    // $FlowIgnore if cache has size, the key exists
    cache.list[index].key.matchesCustom(key, isMultiParamKey, options.equals)) {
      // $FlowIgnore if the key matches, the key exists
      return cache.list[index].key;
    }

    index++;
  }

  return isMultiParamKey ? new _MultipleParameterCacheKey2.default(key) : new _SingleParameterCacheKey2.default(key);
};

/**
 * @private
 *
 * @function getGetCacheKeyMethod
 *
 * @description
 * based on the options, get the getCacheKey method
 *
 * @param {Options} options the options passed to the moized method
 * @returns {function(Cache, Array<*>): CacheKey} the cache key
 */
var getGetCacheKeyMethod = exports.getGetCacheKeyMethod = function getGetCacheKeyMethod(options) {
  if (options.isReact) {
    return options.equals ? getReactCacheKeyCustomEquals : getReactCacheKey;
  }

  if (options.serialize) {
    return options.equals ? getSerializedCacheKeyCustomEquals : getSerializedCacheKey;
  }

  return options.equals ? getStandardCacheKeyCustomEquals : getStandardCacheKey;
};

/**
 * @private
 *
 * @function createGetCacheKey
 *
 * @description
 * create the method that will get the cache key based on the options passed to the moized method
 *
 * @param {Cache} cache the cache to get the key from
 * @param {Options} options the options passed to the moized method
 * @returns {function(*): CacheKey} the method that will get the cache key
 */
var createGetCacheKey = exports.createGetCacheKey = function createGetCacheKey(cache, options) {
  var hasMaxArgs = isFiniteAndPositiveInteger(options.maxArgs);
  var getCacheKeyMethod = getGetCacheKeyMethod(options);

  var transform = options.transformArgs;

  if (hasMaxArgs) {
    transform = transform ? compose(transform, take(options.maxArgs)) : take(options.maxArgs);
  }

  if (options.serialize) {
    transform = transform ? compose(options.serializer, transform) : options.serializer;
  }

  if (options.equals) {
    if (transform) {
      return function (key) {
        // $FlowIgnore transform is a function
        return getCacheKeyMethod(cache, transform(key), options);
      };
    }

    return function (key) {
      return getCacheKeyMethod(cache, key, options);
    };
  }

  if (transform) {
    return function (key) {
      // $FlowIgnore transform is a function
      return getCacheKeyMethod(cache, transform(key));
    };
  }

  return function (key) {
    return getCacheKeyMethod(cache, key);
  };
};

/**
 * @private
 *
 * @function createSetNewCachedValue
 *
 * @description
 * assign the new value to the key in the functions cache and return the value
 *
 * @param {Cache} cache the cache to assign the value to at key
 * @param {Options} options the options passed to the moize method
 * @returns {function(function, *, *): *} value just stored in cache
 */
var createSetNewCachedValue = exports.createSetNewCachedValue = function createSetNewCachedValue(cache, options) {
  var hasMaxAge = isFiniteAndPositiveInteger(options.maxAge);
  var hasMaxSize = isFiniteAndPositiveInteger(options.maxSize);

  var maxAge = options.maxAge,
      maxSize = options.maxSize;


  if (options.isPromise) {
    if (!isFunction(options.promiseLibrary) && !isPlainObject(options.promiseLibrary)) {
      throw new TypeError(_constants.INVALID_PROMISE_LIBRARY_ERROR);
    }

    return function (key, value) {
      var promiseResolver = createPromiseResolver(cache, key, hasMaxAge, options);
      var promiseRejecter = createPromiseRejecter(cache, key, options);
      var handler = value.then(promiseResolver, promiseRejecter);

      cache.add(key, handler);

      if (hasMaxSize && cache.size > maxSize) {
        cache.remove(cache.list[cache.list.length - 1].key);
      }

      return handler;
    };
  }

  return function (key, value) {
    cache.add(key, value);

    if (hasMaxAge) {
      cache.expireAfter(key, maxAge, options.onExpire);
    }

    if (hasMaxSize && cache.size > maxSize) {
      cache.remove(cache.list[cache.list.length - 1].key);
    }

    return value;
  };
};

/**
 * @private
 *
 * @function splice
 *
 * @description
 * faster version of splicing a single item from the array
 *
 * @param {Array<*>} array array to splice from
 * @param {number} startingIndex index to splice at
 * @returns {Array<*>} array minus the item removed
 */
var splice = exports.splice = function splice(array, startingIndex) {
  if (!array.length) {
    return array;
  }

  var index = startingIndex - 1;

  while (++index < array.length) {
    array[index] = array[index + 1];
  }

  array.length -= 1;

  return array;
};

/**
 * @private
 *
 * @function unshift
 *
 * @description
 * faster version of unshifting a single item into an array
 *
 * @param {Array<*>} array array to unshift into
 * @param {*} item item to unshift into array
 * @returns {*} the item just added to the array
 */
var unshift = exports.unshift = function unshift(array, item) {
  var index = array.length;

  while (index--) {
    array[index + 1] = array[index];
  }

  return array[0] = item;
};

/**
 * @private
 *
 * @function createAddPropertiesToFunction
 *
 * @description
 * add the static properties to the moized function
 *
 * @param {Cache} cache the cache for the moized function
 * @param {function} originalFunction the function to be moized
 * @param {Options} options the options passed to the moize method
 * @returns {function(function): function} the method which will add the static properties
 */
var createAddPropertiesToFunction = exports.createAddPropertiesToFunction = function createAddPropertiesToFunction(cache, originalFunction, options) {
  var getCacheKey = createGetCacheKey(cache, options);

  return function (moizedFunction) {
    moizedFunction.cache = cache;
    moizedFunction.displayName = 'moize(' + getFunctionName(originalFunction) + ')';
    moizedFunction.isMoized = true;
    moizedFunction.options = options;
    moizedFunction.originalFunction = originalFunction;

    /**
     * @private
     *
     * @function add
     *
     * @description
     * manually add an item to cache if the key does not already exist
     *
     * @param {Array<any>} key key to use in cache
     * @param {*} value value to assign to key
     */
    moizedFunction.add = function (key, value) {
      var internalKey = getCacheKey(key);

      if (!cache.has(internalKey)) {
        cache.add(internalKey, value);
      }
    };

    /**
     * @private
     *
     * @function clear
     *
     * @description
     * clear the current cache for this method
     */
    moizedFunction.clear = function () {
      cache.clear();
    };

    /**
     * @private
     *
     * @function has
     *
     * @description
     * does the function have cache for the specific args passed
     *
     * @param {Array<*>} key combination of args to remove from cache
     * @returns {boolean} does the cache for the give args exist
     */
    moizedFunction.has = function (key) {
      return cache.has(getCacheKey(key));
    };

    /**
     * @private
     *
     * @function keys
     *
     * @description
     * get the list of keys currently in cache
     *
     * @returns {Array<*>}
     */
    moizedFunction.keys = createPluckFromInstanceList(cache, 'key');

    /**
     * @private
     *
     * @function remove
     *
     * @description
     * remove the item from cache for the key passed for this method
     *
     * @param {Array<*>} key combination of args to remove from cache
     */
    moizedFunction.remove = function (key) {
      cache.remove(getCacheKey(key));
    };

    /**
     * @private
     *
     * @function values
     *
     * @description
     * get the list of values currently in cache
     *
     * @returns {Array<*>}
     */
    moizedFunction.values = createPluckFromInstanceList(cache, 'value');

    return addStaticPropertiesToFunction(originalFunction, moizedFunction);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/moize/lib/utils.js
// module id = ./node_modules/moize/lib/utils.js
// module chunks = 2345137460201621000 9249036036638527000 16304781003358073000